import { Stack, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { routes } from '@blockpulse3/data/shared';
import { LinkButton } from '@blockpulse3/ui/commons';

import { OptionHeader } from './OptionHeader';
import { OptionSummary } from './OptionSummary';

type Props = unknown;

export function OptionView(): JSX.Element {
  const i18nOption = useTranslations('Option');

  const { companyId = '' } = useParams();

  return (
    <Stack spacing="6">
      <LinkButton label={i18nOption('LinkDashboard')} route={routes.workspace.fmt(companyId)} />
      <OptionHeader />
      <Tabs defaultIndex={0} isLazy>
        <TabList>
          <Tab>{i18nOption('TabSummary')}</Tab>
          <Tab isDisabled>{i18nOption('TabDetails')}</Tab>
          <Tab isDisabled>{i18nOption('TabDocuments')}</Tab>
        </TabList>
        <TabPanels>
          <TabPanel px="0">
            <OptionSummary />
          </TabPanel>
          <TabPanel px="0"></TabPanel>
          <TabPanel px="0"></TabPanel>
        </TabPanels>
      </Tabs>
    </Stack>
  );
}

export type OptionViewProps = Props;
